import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

// 从 localStorage 读取语言设置，默认中文
const savedLang = localStorage.getItem('lang') || 'zh'

const i18n = new VueI18n({
    locale: savedLang,
    fallbackLocale: 'zh',
    messages: {
        zh,
        en
    }
})

export default i18n
